<button
    mat-icon-button
    matTooltip="Edit Locale Languages"
>
    <span class="material-icons">chat_bubble_outline</span>
</button>
